const resultList = [
  {
    id:1,
    type:"ビターチェリー猫",
    text1:"そんなに怖がらなくてもいいよ、と思わず声をかけたくなってしまう繊細な猫さんなのかな。はじめて会うほかの猫さんには警戒心MAX。もしかしたら、シャーッ！と威嚇してしまうかもしれません。",
    text2:"相手の存在に慣れてきても、心を許すというまでにはなかなかいかなくて、いつもびくびくしていたり、怖がって避けたりしてしまうかも。ひとりっ子でいる方が、穏やかに過ごせるかもしれませんね。",
    advice:"新しい出会いにはかなり緊張してしまうタイプ。ほかの猫さんに対してどうしてもなじめない場合は、個性として受け止めて、人間（飼い主さん）が猫さんの親友になってあげてもいいのかもしれません。実は猫は人間のことが大好き。人間とずっと一緒に過ごして、大好きになった人間を独り占めできることがビターチェリー猫さんにとっては幸せなのかもしれません。もし人間に対しても慎重派の場合は、いきなり触れたり抱っこしたりせず、ただの同居人として適度な距離での生活をすることから始めることをお勧めします。じっくり仲良くなってみてください。"
  },
  {
    id:2,
    type:"レモン猫",
    text1:"ほかの猫さんのことはちょっと苦手。生まれてこの方、上手なコミュニケーションのとり方を学ぶチャンスが少なかったのかもしれないですね。ほかの猫さんのことが悪い意味で気になってしまうタイプで、相手についていつもネガティブ思考になりがち。",
    text2:"親兄弟とある程度一緒に過ごしていたのなら、もしかしたらほかの猫さんと暮らすことにも抵抗が少ないかもしれないけれど、ずっとひとりだったよ、という猫さんであれば、新しい出会いにはかなり緊張してしまうかもしれません。",
    advice:"新しい出会いにはかなり緊張してしまうタイプ。ほかの猫さんに対してどうしてもなじめない場合は、個性として受け止めて、人間（飼い主さん）がレモン猫さんのの親友になってあげてもいいのかもしれません。実は猫は人間のことが大好き。人間とずっと一緒に過ごして、大好きになった人間を独り占めできることが、レモン猫さんにとって幸せなのかもしれません。"
  },
  {
    id:3,
    type:"キウイ猫",
    text1:"はやくから親兄弟と離れて暮らすようになったのかな？ひとりっ子気質なのかな？いずれにしても、あんまりほかの猫さんのことが好きじゃないみたい。なかなか警戒心が解けず、相手のことを怖い存在と思い込んでしまいがち。",
    text2:"でも、もともとは温厚な性格だから、喧嘩をするというより、じっとしていて、自分から攻撃をしかけていくタイプではなさそうです。ほかの猫と暮らすとしても、この猫さんがひとりきりになれる場所の確保は必要かも。",
    advice:"キウイ猫さんタイプは、他の猫さんとどうお話ししていいのかわからない猫さんかもしれません。ほかの猫に興味があってもどうやって挨拶していいかわからないと、どう接していいのかもわからないので、無理に他の猫と一緒になりたいと思わないかもしれません。もしほかの猫さんを新しい家族として受け入れるのが難しい子であれば、人間（飼い主さん）と仲良くなってくれれば、猫さん自身は幸せに毎日を過ごせます。何とか他の猫さんを受け入れたとしても、ひとりで過ごす時間や場所が必要かもしれません。先住猫さん、新入り猫さんが、それぞれ安心できる場所が確保できるように環境を工夫してあげてください。"
  },
  {
    id:4,
    type:"パイナップル猫",
    text1:"物心ついたころから、ずっとひとりでがんばってきた猫さんみたい。もしかしたら嫌な思いや、怖い経験もしてきたかもしれません。それをひとりで乗り越えてきたと思うと、なんだか抱きしめたくなっちゃう猫さんですね。とても繊細な心を持っていて、知らない猫さんと出会ったときには、引っ込み思案になってしまうかも。",
    text2:"時間をかければ仲良くなれる可能性がないわけではないけど、どちらかというとべったり仲良しになるというより、一緒の空間にいてもとりあえず喧嘩もなく、なんとか大丈夫、というくらいの共同生活になるのかもしれません。",
    advice:"パイナップル猫ちゃんのことはよく見てあげてください。猫さんとお見合いさせるときに、シャーといったり、逃げたり、隠れたりする場合は、ちょっと他の猫さんのことが怖いのかもしれません。どうやって挨拶していいのかわからないのかもしれません。新しく猫さんを家族に迎えたい場合は、まずは人間と暮らす環境に慣れてもらうところから始めて、ゆっくりほかの猫さんとお見合いをさせます。最初は別の部屋で過ごしてもらい、しばらくしたら（数日から数週間かかる場合も）、少し距離をあけた位置から先住猫さんと新入り猫さんがお互いをチラ見するところから始めてみましょう。焦らずゆっくり、様子を見ながらお見合いをさせていくのがいいでしょう。"
  },
  {
    id:5,
    type:"ブルーベリー猫",
    text1:"猫生の早い段階から、ひとりでいきてきた猫さんなのかな。寂しかったかもしれないね。でも、その寂しさが板についてしまって、自分の世界観とは違うほかの猫さんを受け入れる際には、この猫さんなりに勇気がいりそうです。相手がどんな猫さんなのか、自分と気が合うのか、自分のペースを乱したりしないか、気になってしまうタイプ。",
    text2:"相手の性格にもよりますが、孤独な半生由来で、どうしても慎重になりがちです。相手を怖い、と感じてしまう場合もあるようです。",
    advice:"ブルーベリー猫ちゃんは、他の猫さんとどうお話ししていいのかわからない猫さんかもしれません。ほかの猫さんに興味があっても、どうやって挨拶していいかわからないと、どう接していいのかもわからないので、無理に他の猫と一緒になりたいと思わないかもしれません。先住猫さんがブルーベリー猫さんタイプで、もしほかの猫さんを受け入れるのが難しい子であれば、無理にお友達として新しい猫さんを迎え入れなくてもいいのかもしれません。人間（飼い主さん）と仲良くなってくれれば、猫さんにとっては幸せに毎日を過ごすことができます。ぜひ人間家族が猫さんの親友になってあげてください。"
  },
  {
    id:6,
    type:"洋ナシ猫",
    text1:"子供のころからあまりほかの猫さんと接触がなく、どちらかというと孤独にいきてきた猫さんみたいですね。",
    text2:"孤独になれているからひとりがいいタイプなのか、孤独だから本当は仲間がほしかったんだ、というタイプなのか。難しいところですが、おそらくこの猫さんは、もともと気性がおだやかで、ほかの猫さんのことにも興味を示してくれるんじゃないかな。仲良くなれる可能性は充分ありそうです。",
    advice:"先住猫さんが洋ナシ猫ちゃんタイプだった場合、新しく迎える猫さんとお見合いをさせる場合は、じっくり両方の猫ちゃんの様子を見てあげてください。隠れてしまったり、すぐに逃げてしまったりしても、決して無理強いせず、時間をかけてお見合いをさせていくようにしてあげましょう。普段は大好きなおいしいおやつをあげても食べてくれない場合は、とっても緊張している証拠。そんな時はお見合いを中断して、数日間～数週間は別々の部屋で過ごしてもらうなど、もう少しお互いの距離を取ってから、お見合いを再開するようにしましょう。必ずおやつはあげてみて下さいね。「あの子と会うとおやつがもらえる、いいね！」って思ってくれるようになると、仲良くなれるチャンスかも。"
  },
  {
    id:7,
    type:"いちご猫",
    text1:"もともと親兄弟や仲間と一緒に暮らしていたのかな。ほかの猫さんとコミュニケーションをとる、ということはちゃんとわかっている猫さんです。じっくり話せばわかるやつ？",
    text2:"でも、とっても繊細な心の持ち主だから、新しい猫さんと出会ったときに、警戒してしまったり、変にへりくだったりして、下手にまわってしまうことも。「あ、ぼくのことはいいんで、そちらで好きにやっててもらえれば……」なんていって譲って、隠れてしまいそう。",
    advice:"知らない人や猫がいると、つい隠れてしまうような繊細な心を持ついちご猫ちゃん。もし新しいお友達猫さんと初めて会う時にドキドキして隠れてしまうようであれば、無理に会わせようとせず、しばらく隠れさせてあげてください。きっと隠れながら相手のことをじっくり観察して、ゆっくりゆっくり、新しい仲間の存在に納得していくと思います。人間が初対面の相手と会う時、おいしい食べ物を食べながらお見合いするように、猫さん同士もおいしい食べ物がお互いの気持ちをほぐしてくれます。先住猫さんと新入り猫さんのお見合いには、ゆっくり時間をとってあげて、それぞれにおいしいおやつをあげながら、ちょっとずつ対面させていくのもひとつの方法かもしれないですね。"
  },
  {
    id:8,
    type:"アップル猫",
    text1:"ほかの猫さんに対して礼儀正しく挨拶できちゃう猫さんです。でも、だからといって誰でもバッチコイ！ではなく、この猫はいいけど、あの猫はちょっとねぇ、とか、あの猫のああいうところがイヤなんだよねとか、まあそこは許せる、とか、考えていそう。",
    text2:"物心つく頃までずっと親兄弟といたとか、他の猫たちが集まっている場所で育ったとかいった猫さんであれば、ほかの猫への受け入れ姿勢もわりと柔軟だけど、初対面の相手にはちょっと身構えてしまうところもあって、ちょっぴり慎重な側面も。<br />（※エイズキャリアの猫を指す「りんご猫」とは異なる、このアプリ独自のイメージ表現です）",
    advice:"アップル猫さんは見かけは紳士・淑女的に他の猫さんとご挨拶するかもしれませんが、初対面の猫さんに本当は内心ドキドキしているのかもしれません。先住の愛猫さんは、新しくやってきた猫さんに対して紳士・淑女的に見えたり、怖がっていないように見えたりするかもしれません。でも、初めての対面は誰だって緊張しますから、すぐに会わせるのではなく、ゆっくりゆっくり、新入り猫さんと会わせていくようにしてあげましょう。最初は別のお部屋からスタート。先住の愛猫さんと新入猫さんそれぞれの頬をタオルで拭い、お互いのタオルを交換して側におくなどしてみましょう。相手が見えなくても、間接的に相手のフェロモンを感じ取って、少しずつ相手の存在に慣れていってくれるかもしれません。"
  },
  {
    id:9,
    type:"フルーツバスケット猫",
    text1:"コミュ力高っ！ほかの猫さんにちゃんと挨拶ができて、そつなく接することができるタイプの猫さんです。おおらかな性格で、とげとげしていないから、ほかの猫さんのこともすんなり受け入れられるし、相手からも嫌われにくいのかも。ほかにも猫家族がいると、賑やかでいいですね。",
    text2:"猫にはもちろん、食べ物やおもちゃなど、何にでも好奇心旺盛で、遊ぶのが大好きな猫さんであれば、いつもこの猫さんを中心に笑いの絶えない家庭になりそうです。",
    advice:"コミュ力の高い猫さんであっても、やっぱり初対面ではちょっとドキドキしてしまう子もいます。うちの子はおおらか、と飼い主さんが思っていても、新しい猫さんをおうちに迎えるときは、前からいる愛猫さんといきなり一緒に過ごさせるのではなく、時間をかけてゆっくり会わせるようにしましょう。最初は別のお部屋にいてもらい、先住の愛猫さんと新入猫さんそれぞれの頬をタオルで拭い、お互いのタオルを交換して側におくなどしてみましょう。間接的に相手のフェロモンを感じ取って、少しずつ相手の存在に慣れていってくれるかもしれません。"
  }
]

export { resultList }